module.exports = __webpack_public_path__ + "static/media/step_9.26747223.mp3";